import React from 'react';
import {Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {IVendorListItemEntity} from 'pwm-shared/src/types';
import {Scrollbar} from 'src/components/scrollbar';
import {formatDate} from 'src/PWM/utils/date-utils';
import PWMIconButtonLink from 'src/PWM/components/PWMIconButtonLink';
import {PWMViewIcon} from 'src/PWM/components/PWMIcons';
import PWMIsChecked from 'src/PWM/components/PWMIsChecked';
import {tokens} from 'src/PWM/locales/tokens';
import {PWMCard, PWMCardContent, PWMCardHeader} from 'src/PWM/components/PWMCard';

const VendorAssignmentTable: React.FC<IVendorAssignmentTableProps> = (props) => {
  const {projects} = props;
  const {t} = useTranslation();
  return (
    <PWMCard>
      <PWMCardHeader title={t(tokens.interface.projectassignments)}/>
      <PWMCardContent>
        <Scrollbar>
          <TableContainer sx={{height: '50vh'}}>
            <Table size="small" stickyHeader={true}>
              <TableHead>
                <TableRow>
                  <TableCell />
                  <TableCell>{t(tokens.interface.contract)}</TableCell>
                  <TableCell>{t(tokens.interface.project)}</TableCell>
                  <TableCell>{t(tokens.interface.assignedon)}</TableCell>
                  <TableCell>{t(tokens.interface.dirclassifications)}</TableCell>
                  <TableCell>{t(tokens.interface.active)}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {projects.map((p) => {
                  return (
                    <TableRow key={p.id}>
                      <TableCell>
                        <PWMIconButtonLink href={`/contracts/${p.list.projectId}`}><PWMViewIcon /></PWMIconButtonLink>
                      </TableCell>
                      <TableCell>{p.list?.project?.contractNumber}</TableCell>
                      <TableCell>{p.list?.project?.name}</TableCell>
                      <TableCell>{formatDate(p.created)}</TableCell>
                      <TableCell>{p.classifications.map(({classification: {name}}) => name).join(', ')}</TableCell>
                      <TableCell><PWMIsChecked checked={p.isActive} /></TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </Scrollbar>
      </PWMCardContent>
    </PWMCard>
  );
};

export default VendorAssignmentTable;

interface IVendorAssignmentTableProps {
  children?: React.ReactNode;
  projects: IVendorListItemEntity[];
}